import { Grid } from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';

class StockTransferDetailDialogStyle extends CommonComponentStyle {
  TitleWrapper = styled(Grid)`
    background: ${this.colors.LIGHTER_GRAY};
    padding: 16px;
    color: ${this.colors.PRIMARY_GRAY};
  `;

  DocumentInformationWrapper = styled(Grid)`
    padding: 24px 16px 32px 16px;
  `;

  DocumentInfoTitle = styled.p`
    color: ${this.colors.PRIMARY_GRAY};
    font-size: 12px;
    margin: 0;
  `;

  DocumentInfoValue = styled.p`
    font-size: 14px;
    margin: 8px 0 0 0;
    word-break: break-word;
  `;

  TableSection = styled.div`
    overflow-y: auto;
    border-top: 1px solid ${this.colors.LIGHT_GRAY};
    margin: 0 16px;
    padding: 16px 0;
  `;

  ActionWrapper = styled(Grid)`
    padding: 0 16px 16px 16px;
  `;
}

export default new StockTransferDetailDialogStyle();
